import { Link } from 'react-router-dom'
import { Instagram } from 'lucide-react'

export default function Footer() {
  return (
    <footer className="relative bg-white text-primary border-t border-slate-200 overflow-hidden">
      <div className="container relative z-10 py-4 md:py-5">
        {/* Desktop: socials left, logo center, copyright right */}
        {/* Mobile: logo, socials, copyright (stacked) */}
        <div className="flex flex-col md:grid md:grid-cols-3 items-center gap-4">
          {/* Social links - center on desktop, 2nd on mobile */}
          <div className="flex items-center gap-5 order-2 md:order-2 md:justify-self-center">
            <a
              href="https://www.instagram.com/gigafish.co/"
              target="_blank"
              rel="noopener noreferrer"
              className="text-slate-500 hover:text-accent transition-colors"
              aria-label="Instagram"
            >
              <Instagram className="h-5 w-5" />
            </a>
            <a
              href="https://www.linkedin.com/company/gigafish-co"
              target="_blank"
              rel="noopener noreferrer"
              className="text-slate-500 hover:text-accent transition-colors"
              aria-label="LinkedIn"
            >
              <svg className="h-5 w-5" viewBox="0 0 24 24" fill="currentColor" aria-hidden>
                <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
              </svg>
            </a>
            <a
              href="https://x.com/gigafish_co"
              target="_blank"
              rel="noopener noreferrer"
              className="text-slate-500 hover:text-accent transition-colors"
              aria-label="X"
            >
              <svg className="h-5 w-5" viewBox="0 0 24 24" fill="currentColor" aria-hidden>
                <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
              </svg>
            </a>
            <a
              href="https://www.tiktok.com/@gigafish.co"
              target="_blank"
              rel="noopener noreferrer"
              className="text-slate-500 hover:text-accent transition-colors"
              aria-label="TikTok"
            >
              <svg className="h-5 w-5" viewBox="0 0 24 24" fill="currentColor" aria-hidden>
                <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z" />
              </svg>
            </a>
          </div>

          {/* Logo - center on desktop, 1st on mobile */}
          <Link
            to="/"
            onClick={(e) => {
              if (window.location.pathname === '/') {
                e.preventDefault()
                window.scrollTo({ top: 0, behavior: 'smooth' })
              }
            }}
            className="flex items-center gap-2 h-10 group order-1 md:order-1 md:justify-self-start"
          >
            <img src="/assets/gigafish-brandmark.svg" alt="Gigafish" className="h-10 w-auto object-contain footer-logo-img" />
            <img src="/assets/gigafish-wordmark.svg" alt="Gigafish" className="h-5 w-auto object-contain footer-logo-img" />
          </Link>

          {/* Copyright & legal links - right on desktop, 3rd on mobile */}
          <div className="flex flex-col items-center md:items-end gap-2 text-xs order-3 md:order-3 md:justify-self-end text-center md:text-right">
            <div className="flex flex-wrap items-center justify-center md:justify-end gap-x-3 gap-y-1 text-slate-600">
              <span>© {new Date().getFullYear()} Gigafish.</span>
              <span>ABN 59790713440</span>
            </div>
            <div className="flex items-center justify-center md:justify-end gap-4">
              <Link
                to="/privacy"
                className="text-accent underline decoration-accent underline-offset-2 hover:bg-accent hover:text-white hover:no-underline focus:bg-accent focus:text-white focus:no-underline px-2 py-1 -mx-2 -my-1 rounded transition-colors"
              >
                Privacy Policy
              </Link>
              <Link
                to="/terms"
                className="text-accent underline decoration-accent underline-offset-2 hover:bg-accent hover:text-white hover:no-underline focus:bg-accent focus:text-white focus:no-underline px-2 py-1 -mx-2 -my-1 rounded transition-colors"
              >
                Terms of Service
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  )
}
